import { OTA_Address } from "./ota_address.model";
import { OTA_PersonName } from "./ota_personname.model";
import { OTA_Telephone } from "./ota_telephone.model";

export class OTA_OffLocService {
    public type: string;
    public address = new OTA_Address();
    public personName = new OTA_PersonName();
    public telephone = new OTA_Telephone();
}